import { useSelector } from "react-redux";
import { FlexRow, Wrapper, TextWrapper } from "../../../constants/common/StyledGlobalConstants";
import CamerasAndAccessoriesDetails from "./CamerasAndAccessoriesDetails";
import ContractAndCancellationsFAQWarning from "../common/ContractAndCancellationsFAQWarning";
import VehicleDetails from "./VehicleDetails";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

const ServiceDetails = ({ serviceDetails, toSetValueFAQ }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const isMobile = windowSize.width < TABLET;

  const allServiceDetails = [
    ...serviceDetails
      .map((serviceData) =>
        serviceData.servicesDetails.map((service) => ({
          ...service,
          serviceType: serviceData.type.toLowerCase() === "transfer" ? "Transfer" : "Removal",
        }))
      )
      .flat(),
  ];

  return (
    <Wrapper marginTop={isMobile ? "1.5rem" : "2rem"}>
      <TextWrapper fontSize="1.5rem" fontWeight="700" lineHeight="2rem">
        Service required
      </TextWrapper>
      {allServiceDetails.map((service, index) => {
        const { serviceType, relatedServices, existingVehicle, newVehicle } = service;
        const {
          id,
          vin: oldVin,
          vehicleName: oldVehicleName,
          revealCoreESN: oldRevealCoreESN,
          registrationNumber: oldRegistrationNumber,
        } = existingVehicle;
        const newVehicleData = serviceType === "Transfer";
        const isVin = !!oldVin;
        newVehicleData ? toSetValueFAQ(false) : toSetValueFAQ(true);
        return (
          <Wrapper marginTop="1rem" fontSize="0.875rem" border="1px solid #D8DADA" borderRadius="8px" key={id}>
            <Wrapper padding="1.5rem">
              <TextWrapper fontSize="1.25rem" fontWeight="700" lineHeight="1.5rem">
                {serviceType}
              </TextWrapper>
              <FlexRow marginTop="1rem">
                <VehicleDetails
                  vin={oldVin}
                  vehicleName={oldVehicleName}
                  esn={oldRevealCoreESN}
                  registrationNumber={oldRegistrationNumber}
                  isVin={isVin}
                />
                {!isMobile && isVin && <CamerasAndAccessoriesDetails camerasAndAccessories={relatedServices} />}
              </FlexRow>
              {newVehicleData ? (
                newVehicle?.vehicleName && (
                  <Wrapper marginTop={newVehicleData && "1rem"}>
                    <VehicleDetails vin={newVehicle?.vin} vehicleName={newVehicle?.vehicleName} isVin={isVin} newVehicleData />
                    {isMobile && isVin && <CamerasAndAccessoriesDetails camerasAndAccessories={relatedServices} />}
                  </Wrapper>
                )
              ) : (
                <>
                  {isMobile && isVin && <CamerasAndAccessoriesDetails camerasAndAccessories={relatedServices} />}
                  <Wrapper fontWeight="400" fontSize="0.875rem" flex="1" marginTop="1.5rem">
                    <ContractAndCancellationsFAQWarning parentComponent="ServiceDetails" />
                  </Wrapper>
                </>
              )}
            </Wrapper>
          </Wrapper>
        );
      })}
    </Wrapper>
  );
};

ServiceDetails.propTypes = {
  serviceDetails: PropTypes.array.isRequired,
  toSetValueFAQ: PropTypes.func.isRequired,
};

export default ServiceDetails;